import { StandardEvents } from '@shopify/events';
class BrazurProductName extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.updateName);
  }
  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.updateName);
  }
  updateName = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;
    const request = this.latestRequest = event.promise;
    request?.then(({ detail }) => {
      if (this.latestRequest !== request || !this.isConnected || !detail?.html) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector('brazur-product-name');
      if (next) this.textContent = next.textContent;
    }).catch(error => {
      if (error?.name !== 'AbortError') console.warn('[brazur-product-name]', error);
    });
  };
}
if (!customElements.get('brazur-product-name')) customElements.define('brazur-product-name', BrazurProductName);
